import { accountStatsLoadByDateSaga } from "redux-store/ui-state/account-stats/sagas";

import { adDeliveryReportSaga } from "./ad-delivery-report/sagas";
import { deviceEventsV3Saga } from "./device-events-v3/sagas";
import { loadDeviceEventsSaga } from "./device-events/sagas";
import { loadIncidentsByDeviceIdSaga } from "./device-incidents/sagas";
import { loadDeviceResourcesSaga } from "./device-resources/sagas";
import { loadDeviceStatsSaga } from "./device-stats/sagas";
import { eventsV3Sagas } from "./events-v3/sagas";
import { incidentSagas } from "./incidents/sagas";
import { networkDeviceVersionsSaga } from "./network-device-versions/sagas";
import { playerVersionsSaga } from "./player-versions/sagas";
import { fetchIncidentDetailReportSaga } from "./report-incident/sagas";
import { deviceUptimeReportSaga } from "./report-uptime-device/sagas";
import { devicesUptimeReportSaga } from "./report-uptime-devices/sagas";
import { uptimeReportSaga } from "./report-uptime/sagas";
import { tagsSaga } from "./tags/sagas";

const reportSagas = [
  adDeliveryReportSaga(),
  deviceUptimeReportSaga(),
  devicesUptimeReportSaga(),
  fetchIncidentDetailReportSaga(),
  uptimeReportSaga(),
];

// Load any ui-state specific sagas here.
const pageSagas = [
  accountStatsLoadByDateSaga(),
  deviceEventsV3Saga(),
  loadDeviceEventsSaga(),
  loadDeviceResourcesSaga(),
  loadDeviceStatsSaga(),
  loadIncidentsByDeviceIdSaga(),
  networkDeviceVersionsSaga(),
  playerVersionsSaga(),
  tagsSaga(),
  ...eventsV3Sagas,
  ...incidentSagas,
  ...reportSagas,
];

export { pageSagas };
